import { showErrorModal } from "../store/slices/errorModalSlice";
import { refreshAccessToken } from "../services/apiAuth";
import translation from "../data/fa-IR.json";

type RequestFn<T> = () => Promise<T>;

interface HandleThunkRequestArgs<T> {
  thunkAPI: {
    dispatch: any;
    rejectWithValue: (value: any) => any;
  };
  requestFn: RequestFn<T>;
  method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH" | "NET";
  redirectOn401?: boolean;
  errorPresentation?: "modal" | "inline" | "silent";
}

export async function handleThunkRequest<T>({
  thunkAPI,
  requestFn,
  method = "GET",
  redirectOn401 = true,
  errorPresentation = "modal",
}: HandleThunkRequestArgs<T>): Promise<
  T | ReturnType<typeof thunkAPI.rejectWithValue>
> {
  const { dispatch, rejectWithValue } = thunkAPI;

  if (!navigator.onLine) {
    const offlineError = {
      title: translation.Global.Warnning,
      detail: translation.Global.NetworkError,
    };

    dispatch(showErrorModal({ ...offlineError, method }));

    return rejectWithValue(offlineError);
  }

  try {
    return await requestFn();
  } catch (error: any) {
    if (error?.status === 401 && redirectOn401) {
      try {
        await refreshAccessToken();
        return await requestFn(); // retry after refresh
      } catch {
        window.location.href = "/login";
        return rejectWithValue(error);
      }
    }

    if (errorPresentation === "modal") {
      dispatch(
        showErrorModal({
          title: error.title,
          detail: error.detail,
          method,
        })
      );
    }

    // "inline" and "silent" both just propagate the error to the caller
    return rejectWithValue(error);
  }
}
